'use strict';
/* jshint ignore:start */
var login = {
	loginEvent: function (status, email) {
		if (email === undefined) {
			if ($('input[name*=_login_username').length > 0) {
				email = $('input[name*=_login_username').val();
			} else if ($('input[name=loginEmail').length > 0) {
				email = $('input[name=loginEmail').val();
			}
		}

		var loginStatus = '';
		if (status === 'false') {
			loginStatus = 'failed';
		} else if (status === 'true') {
			loginStatus = 'success';
		}

		var  accountLocked = '';
		var  customerType = '';
		if ($('input[name=pageLoadData]').length > 0) {
			var customerData = JSON.parse($('input[name=customerPageLoadData]').val());
			accountLocked = customerData.re_account_locked;
			customerType = customerData.new_customer_registered;
		}

		var obj = {
			'event': 'login',
			'button_ID': 'dwfrm_login_login',
			'login_success': loginStatus,
			'new_customer_registered': customerType,
			're_account_locked': accountLocked,
			're_email_address': email
		};
		dataLayer.push(obj);
	},
	registrationConfirmationAttemptEvent: function (page) {
		var obj = {
			'event': 'registrationConfirmation',
			'event_step':'Attempt',
			'sign_up_page':page ? page : window.pageContext.title,
			'error_message':'Not Applicable'
		};
		dataLayer.push(obj);
	}
};
module.exports = login;
/* jshint ignore:end */
